<template>
  <div class="mcq-report">
    <div class="main-content" v-if="!isUserGroupAdmin">
      <report-filter-bar @selectedGroupObj="setGroupCourseObj" @selectedCohortObj="setCohortObj" v-bind:showExport="showExportButton" @isExportBtnClicked="exportCSV" @isViewBtnClicked="updateViewBtnClickedFlag"></report-filter-bar>
      <!-- <report-group-course-filter-bar @selectedGroupObj="setGroupCourseObj" v-bind:showExport="showExportButton" @isExportBtnClicked="exportCSV" @isViewBtnClicked="updateViewBtnClickedFlag"></report-group-course-filter-bar> -->
      <hr width="94%" size="10px">
      <div class="row margin-Top-2Perc">
        <div class="col-md-12 col-lg-12 width-97Point4 margin-left-1point5Perc">
          <sortable-list v-if="showMCQReportList" v-bind:responseObj="getMCQArrResp" v-bind:sortableColumnName="sortColumnNames" v-bind:columnNameToShow="columnNameToShow" v-bind:linkColumnName="linkColumnNames" v-bind:selectedsubOption="6"></sortable-list>
        </div>
      </div>
      <div class="row margin-Top-3Perc">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <Copyright-Element class="footer"></Copyright-Element>
        </div>
      </div>
      <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>
      <!-- Show Spinner -->
      <div class="animationload" v-show="showSpinner">
        <div class="osahanloading"></div>
      </div>
    </div>
    <loader></loader>
    <error-page v-if="isUserGroupAdmin"></error-page>
  </div>
</template>

<script>
// import ReportGroupCourseFilterBar from '@/components/ReportGroupCourseFilterBar'
import ReportFilterBar from '@/components/ReportFilterBar'
import { trackerService } from '@/server-util/tracker-service'
import { constants } from '@/utils/constants'
import CopyrightElement from '@/components/CopyrightElement'
import csvHelper from '@/utils/csv-helper'
import list from '@/pages/SortableList'
import AlertBox from '@/components/AlertOverlay'
import { reportService } from '@/server-util/report-service'
import ErrorPage from '@/pages/Error'
import Loader from '@/components/dashboard/Loader'
import { participantService } from '@/server-util/participant-service'
export default {
  created: function () {
    this.checkUserErrorStatus()
  },
  data: function () {
    return {
      selectedGroupObj: null,
      selectedCohortObj: null,
      showExportButton: true,
      errorMsg: '',
      showSpinner: false,
      showAlertDialog: false,
      mcqRespArr: [],
      showMCQReportList: false,
      sortColumnNames: ['QuestionText', 'QuestionType', 'CorrectAnswer', 'MostSelectedOption', 'AverageAttempts'],
      columnAlias: ['MCQ Title', 'MCQ Type', 'Correct Option', 'Most Selected Option', 'Average # of Attempts'],
      columnAliasForCSV: ['MCQ Title', 'MCQ Type', 'Correct Option', 'Most Selected Option', 'Average # of Attempts'],
      columnRespKey: ['QuestionText', 'QuestionType', 'CorrectAnswer', 'MostSelectedOption', 'AverageAttempts'],
      columnRespKeyForCSV: ['QuestionText', 'QuestionType', 'CorrectAnswer', 'MostSelectedOption', 'AverageAttempts'],
      columnNameToShow: [],
      linkColumnNames: ['Action'],
      isExportBtnClicked: false,
      isViewBtnClicked: false,
      csvFileName: 'MCQReport',
      responseToPass: [],
      prevGCMId: ''
    }
  },
  components: {
    'Copyright-Element': CopyrightElement,
    'report-filter-bar': ReportFilterBar,
    'sortable-list': list,
    'alert-box': AlertBox,
    'error-page': ErrorPage,
    'loader': Loader
  },
  methods: {
    checkUserErrorStatus: function () {
      var storeObj = this.$store
      if (storeObj.state.access_token !== undefined && storeObj.state.access_token !== null && storeObj.state.access_token !== '') {
        participantService
          .getUserErrorStatus(
            storeObj.state.access_token
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              const jsonObj = responseObj.data
              this.checkAndShowAlert(jsonObj)
            }
          }, errorObj => {
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
            console.log('getUserErrorStatus Error :::' + this.errorMsg)
          })
      } else {
        console.log(
          'Access Token or required data is NULL hence declined LOADING GET ERROR INFO'
        )
      }
    },
    checkAndShowAlert: function (jsonObj) {
      if (jsonObj !== undefined && jsonObj !== 'undefined' && jsonObj !== null && jsonObj !== 'null' && jsonObj !== '') {
        const isLoggedOut = jsonObj.IsAdminLoggedOut
        const profileError = jsonObj.ProfileError
        if (isLoggedOut) {
          this.showAlertDialog = true
          this.errorMsg = constants.Logged_Out_From_Another_Platform_Error_Msg
        } else if (profileError === constants.Change_Password_Error_Profile) {
          this.showAlertDialog = true
          this.errorMsg = constants.Change_Password_Alert_Msg
        }
      }
    },
    peformCleanUpOperationOnSignOut: function () {
      var store = this.$store
      var cookies = this.$cookies
      cookies.remove(constants.LOGIN_COOKIE_KEY)
      cookies.remove(constants.LOGIN_USER_COOKIE)
      store.state.isUserProfileLoaded = false
      localStorage.removeItem(constants.LOGIN_USER_COOKIE)
      localStorage.setItem('selectedMenu', 0)
      localStorage.setItem('selectedSubMenu', 0)
      localStorage.clear()
      this.$store.state.curr_user = null
      this.$store.commit('resetState')
      this.$router.push('/')
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
      switch (this.errorMsg) {
        case constants.Logged_Out_From_Another_Platform_Error_Msg:
          this.peformCleanUpOperationOnSignOut()
          break
        case constants.Change_Password_Alert_Msg:
          localStorage.setItem('selectedMenu', constants.MenuOptionsEnum.Settings)
          localStorage.setItem('selectedSubMenu', constants.SubMenuOptionsEnum.EditProfile)
          this.$router.push('/profile?OpenPopUp=true')
          break
      }
    },
    trackPageLoad () {
      var store = this.$store
      var accessToken = store.state.access_token
      var userData = store.state.curr_user
      var userDataForActivity = 'UserName:{0}, FullName: {1}'
      userDataForActivity = userDataForActivity.replace('{0}', userData.UserName)
      userDataForActivity = userDataForActivity.replace('{1}', userData.FirstName + ' ' + userData.LastName)
      var trackingObj = {
        ActivityData: 'Load Discussions Page, ' + userDataForActivity,
        ActivityType: constants.AdminActivityType.Discussions,
        AdminAction: constants.AdminActionType.LoadScreen,
        ScreenName: 'DISCUSSIONS',
        UserRole: store.state.curr_user.AccountType,
        IsPrivate: false
      }
      trackerService.logActivity(accessToken, trackingObj).then(responseObj3 => {
        if (responseObj3.status === 200) {
          console.log('LOGGED ACTIVITY : ')
        }
      })
    },
    setGroupCourseObj (value) {
      // AK: When user selected particular group object then update it in parent file too
      this.selectedGroupCourseObj = value
    },
    setCohortObj (value) {
      // AK: When user selected particular cohort object then update it in parent file too
      this.selectedCohortObj = value
    },
    updateViewBtnClickedFlag (value) {
      this.isViewBtnClicked = value
      if (value) {
        // this.bindColumnsNameAndAlias()
        this.csvFileName = 'MCQReport(' + this.selectedGroupCourseObj.GroupName + '-' + this.selectedGroupCourseObj.CourseTitle + ')'
        this.getMCQReport()
      }
    },
    exportCSV (value) {
      this.isExportBtnClicked = value
      if (value) {
        // this.bindColumnsNameAndAlias()
        this.csvFileName = 'MCQReport(' + this.selectedGroupCourseObj.GroupName + '-' + this.selectedGroupCourseObj.CourseTitle + ')'
        this.getMCQReport()
      }
    },
    addColumnAlias: function () {
      this.columnAlias = []
      this.columnAliasForCSV = []
      this.columnAlias = ['MCQ Title', 'MCQ Type', 'Correct Option', 'Most Selected Option', 'Average # of Attempts']
      this.columnAliasForCSV = ['MCQ Title', 'MCQ Type', 'Correct Option', 'Most Selected Option', 'Average # of Attempts']
      for (var i = 0; i < this.mcqRespArr.MaxOptions; i++) {
        this.columnAlias.push('Option ' + String.fromCharCode(65 + i))
        this.columnAliasForCSV.push('Option ' + String.fromCharCode(65 + i))
      }
      this.columnAlias.push('Action')
      // console.log('this.columnAlias >>>> ' + JSON.stringify(this.columnAlias))
      this.addColumnRespKey()
    },
    addColumnRespKey: function () {
      this.columnRespKey = []
      this.columnRespKeyForCSV = []
      this.columnRespKey = ['QuestionText', 'QuestionType', 'CorrectAnswer', 'MostSelectedOption', 'AverageAttempts']
      this.columnRespKeyForCSV = ['QuestionText', 'QuestionType', 'CorrectAnswer', 'MostSelectedOption', 'AverageAttempts']
      for (var i = 0; i < this.mcqRespArr.MaxOptions; i++) {
        this.columnRespKey.push('Option_' + String.fromCharCode(65 + i))
        this.columnRespKeyForCSV.push('Option_' + String.fromCharCode(65 + i))
      }
      this.columnRespKey.push('Action')
      // console.log('this.columnRespKey >>>> ' + JSON.stringify(this.columnRespKey))
      this.bindResponseObj()
    },
    bindResponseObj: function () {
      this.responseToPass = []
      // AK: Itrate Loop till max number of rows
      for (var i = 0; i < this.mcqRespArr.Questions.length; i++) {
        // AK: Create obj and assign defaults values
        const questionType = this.mcqRespArr.Questions[i].IsIntrospection ? 'Introspection' : this.mcqRespArr.Questions[i].QuestionType
        var obj = {
          QuestionText: this.mcqRespArr.Questions[i].QuestionText,
          QuestionType: questionType,
          CorrectAnswer: this.mcqRespArr.Questions[i].CorrectAnswer,
          MostSelectedOption: this.mcqRespArr.Questions[i].MostSelectedOption,
          AverageAttempts: this.mcqRespArr.Questions[i].AverageAttempts,
          QuestionId: this.mcqRespArr.Questions[i].QuestionId,
          IsIntrospection: this.mcqRespArr.Questions[i].IsIntrospection,
          Action: 'Participants'
        }
        // AK: Add dynamically options into temp defined obj
        for (var j = 0; j < this.mcqRespArr.MaxOptions; j++) {
          var optionNo = String.fromCharCode(65 + j)
          // AK: Assign default value NA initially
          obj['Option_' + optionNo] = 'NA'
          // AK: Iterate loop and assign percentage to respective option
          for (var k = 0; k < this.mcqRespArr.Questions[i].Options.length; k++) {
            // console.log(this.mcqRespArr.Options[i].OptionNo + ' and ' + optionNo)
            if (this.mcqRespArr.Questions[i].Options[k].OptionNo === optionNo) {
              obj['Option_' + optionNo] = this.mcqRespArr.Questions[i].Options[k].Percentage + '%'
            }
          }
        }
        this.responseToPass.push(obj)
      }
      // console.log('this.responseToPass >>>> ' + JSON.stringify(this.responseToPass))
      this.bindColumnsNameAndAlias()
    },
    bindColumnsNameAndAlias: function () {
      this.columnNameToShow = []
      for (var i = 0; i < this.columnRespKey.length; i++) {
        var obj = {
          ColumnName: this.columnRespKey[i],
          ColumnAlias: this.columnAlias[i]
        }
        this.columnNameToShow.push(obj)
      }
      // console.log('Column And alias Name Obj >>>> ' + JSON.stringify(this.columnNameToShow))
      this.processAndExecuteSelectedOperation()
    },
    getMCQReport: function () {
      var storeObj = this.$store
      var _this = this
      if (this.selectedCohortObj.CohortId !== null || this.selectedCohortObj.CohortId !== undefined || this.selectedCohortObj.CohortId !== '') {
        // this.showSpinner = true
        this.$store.state.isLoading = true
        // AK: Store this in state to access in get Participant call
        storeObj.state.mcqReportSelectedGCMObj = this.selectedGroupCourseObj
        reportService.getMCQReportData(storeObj.state.access_token, _this.selectedCohortObj.CohortId).then(
          responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Hide Spinner after recieving
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
              _this.mcqRespArr = responseObj.data
              // console.log('this.mcqRespArr >>>> ' + JSON.stringify(_this.mcqRespArr))
              if (parseInt(_this.mcqRespArr.length) === 0) {
                this.showAlertDialog = true
                // var subCourseTitle = this.selectedGroupCourseObj.CourseSubTitle !== null && this.selectedGroupCourseObj.CourseSubTitle.trim().length !== 0 ? '[' + this.selectedGroupCourseObj.CourseSubTitle + ']' : ''
                // this.errorMsg = 'No report found for \'' + this.selectedGroupCourseObj.GroupName + '::' + this.selectedGroupCourseObj.CourseTitle + subCourseTitle + '\'.'
                this.errorMsg = 'No report found for \'' + this.selectedCohortObj.CohortName + '\' cohort.'
                this.showMCQReportList = false
              } else {
                this.addColumnAlias()
                // AK: If prev selected GCM id is not same then re-bind everything
                /* if (this.prevGCMId !== this.selectedGroupCourseObj.GroupCourseMasterId) {
                  this.prevGCMId = this.selectedGroupCourseObj.GroupCourseMasterId
                  this.addColumnAlias()
                } else {
                  // AK: If Obj is re-binded already then process next
                  this.processAndExecuteSelectedOperation()
                } */
              }
            } else {
              // AK: Hide Spinner
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
              this.showAlertDialog = true
              this.errorMsg =
                'Oops! Something went wrong. Please try again.'
            }
          },
          errorObj => {
            // AK: Hide Spinner
            // _this.showSpinner = false
            _this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          }
        )
      } else {
        console.log('COHORT ID is NULL hence declined LOADING Deep Dive Participant LIST')
      }
    },
    processAndExecuteSelectedOperation: function () {
      if ((!this.isExportBtnClicked) && this.isViewBtnClicked) {
        // AK: If export btn not clicked and list is shown previously then show list only
        this.showMCQReportList = true
      } else if (this.isExportBtnClicked && (!this.isViewBtnClicked)) {
        // AK: If user directly clicked on export button without clicking view first then export data
        this.exportData()
      } else if (this.isExportBtnClicked && this.isViewBtnClicked) {
        // AK: If user performed both operations then performed both operations
        this.showMCQReportList = true
        this.exportData()
      }
    },
    exportData: function () {
      return csvHelper.export(this.getMCQArrResp, this.columnRespKeyForCSV, this.columnAliasForCSV, this.csvFileName)
    }
  },
  computed: {
    getMCQArrResp: {
      get: function () {
        return this.responseToPass
      }
    },
    isUserGroupAdmin: {
      get: function () {
        var userObj = this.$store.state.curr_user
        if (parseInt(userObj.AccountType) === parseInt(constants.UserAccountType.Group_Admin)) {
          return true
        } else {
          return false
        }
      }
    }
  },
  name: 'mcq-report'
}
</script>

<style scoped>
.mcq-report {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.border-red{
  border: 1px solid red;
}
.border-yellow{
  border: 2px solid yellow;
}
/* Using Only for footer */
.footer{
    /* position: fixed; */
    left: 38px !important;
    bottom: 0 !important;
    width: 100% !important;
    /* background-color: red; */
    /* color: white; */
    text-align: center !important;
    margin-bottom: 1% !important;
    font-size: 12px !important;
}
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/MCQReport.vue